<!--
 * @Author: your name
 * @Date: 2022-03-02 11:30:06
 * @LastEditTime: 2022-12-06 17:28:53
 * @LastEditors: pyx 3245266940@qq.com
 * @Description: 电子合同 意愿验证
 * @FilePath: \wx-front\src\views\contract\verification.vue
-->
<template>
<div class="wrap fontH3">
    <div class="fontScN8 fontH0 medium">意愿验证</div>
    <div class="fontScN7 fontH1 phoneLine">接收手机号码：{{diaplayPhone}}</div>
    <div class="rowJbAc inputBox borderScN4">
        <input
            type="tel"
            class="telInput"
            placeholder="输入验证码"
            maxlength="6"
            v-model="code"
          />
          <div class="fontMcA1" @click="sendVerificationCode" :class="[(!isSendCode) ?' fontMcA1':'reciveCodeBeforeColor']">{{ isSendCode ? `重新获取(${awaitSec}s)` : "发送验证码" }}</div>
    </div>
    <div class="ensureBtn rowJcAc fontScW bgcMcA1" @click="clickEnsure">确定</div>
    <div class="fontH4 fontScN7 tipsLine"><span class="fontScN6">已阅读并同意</span>电子签用户协议、电子签隐私协议、数字证书申请协议</div>
    
</div>
</template>

<script>
import {postSendVerifyCodeAPI} from "../../utils/api/api";
import {postCheckVerifyCodeAPI,putSigningContractAPI} from "../../utils/api/contractAPI";
export default {
  data() {
    return {
        computeTime: 0, //计算再次获取验证码的倒计时
        timer: null, //获取验证码的定时器
        code:'',//验证码
        phone:'',//接收验证码的手机号码
        awaitSec: 60, //计算再次获取验证码的倒计时
        timer: null, //获取验证码的定时器
        isSendCode: false, // 是否发送验证码
        customerId:'',//客户id
        signatureImageUrl:'',//签名的图片地址
        id:'',//合同id

    };
  },
    computed: {
    },
    watch: {
    },
  created() {
      if(this.$common.getCache("customerInfo")){
        var data = JSON.parse(this.$common.getCache("customerInfo"))
        this.phone = data.phone
        var reg = /^(\d{3})\d{4}(\d{4})$/; 
        this.diaplayPhone = this.phone.replace(reg, "$1****$2")
    }
  },
  mounted() {
      if(this.$route.params.customerId){
            this.customerId = this.$route.params.customerId
            this.id = this.$route.params.id
            this.signatureImageUrl = this.$route.params.signatureImageUrl
      }
      
  }, 
   beforeRouteLeave(to, from,next) {
      console.log('beforeRouteLeave')
    // 在导航离开渲染该组件的对应路由时调用
    // 与 `beforeRouteUpdate` 一样，它可以访问组件实例 `this`
    if(this.timer) {
        clearInterval(this,this.timer)
        this.isSendCode = false
    }
    next()
  },
  methods: {
    //点击确定
    clickEnsure(){
        if(this.code) {
            var obj = {
                phone: this.phone,
                verifyCode: this.code
            }
            postCheckVerifyCodeAPI(obj).then(res => {
                if(res.resultCode == 200) {
                    this.putSigningContract()
                }else {
                    this.$toast(res.resultStr)
                }
            })
        }else{
            this.$toast('请输入短信验证码');
        }
    },
     //签署合同
    putSigningContract(){
        var obj = {
            customerId: this.customerId,
            id:this.id,
            signatureImageUrl:this.signatureImageUrl
        }
        putSigningContractAPI(obj).then(res => {
            if(res.resultCode == 200) {
                this.$router.push({
                    name: "SignPassed",
                    // params: { submit: true },
                });
            }
        })
        
    },
    //点击发送验证码
    sendVerificationCode(){
        if(this.isSendCode) return
      
        this.isSendCode = true
        postSendVerifyCodeAPI({phone: this.phone}).then(res => {
            if (res.resultCode == 200) {
                this.isSendCode = true
                this.timer = setInterval(() => {
                    if (this.awaitSec == 1) {
                        clearInterval(this.timer)
                        this.awaitSec = 60
                        this.isSendCode = false
                    }
                    this.awaitSec = this.awaitSec - 1
                }, 1000)
            } else {
                this.isSendCode = false
                this.$toast(res.resultStr)
            }
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.wrap {  
background: #fff;
height: 100%;
box-sizing: border-box;
padding: 0.84rem 0.4rem 0.4rem 0.4rem;
}
.phoneLine{
    margin: 0.24rem 0 0.2rem 0;
}
.inputBox{
    width: 100%;
    height: 48px;
    border-radius: 6px;
    border-style: solid;
    border-width: 1px;
    padding: 0 0.16rem;
    box-sizing: border-box;
    input {
        width: 50%;
    }
}
.ensureBtn{
    width: 100%;
    height: 44px;
    border-radius: 6px;
    margin-top: 60px;
}
.reciveCodeBeforeColor{
    color: rgba(105, 133, 255, 0.4);
}
.tipsLine{
    position: fixed;
    bottom: 40px;
    padding-right: 0.4rem;
    box-sizing: border-box;
}
</style>

